/**
 * @generated SignedSource<<e4c5121ee28b942115265381ec987e29>>
 * @relayHash e33ffe6be783218f5cfc2bcdf60c2bd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a4d71e9d10553df176b5de5e5f79502b970da53471ef25f517d1d3342af03f24

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type ContentSpecificCreateInput = {
  key: string;
  value: string;
};
export type CreateContentMutation$variables = {
  contentSpecificCreateInput?: ReadonlyArray<ContentSpecificCreateInput> | null | undefined;
  parentId?: string | null | undefined;
  spaceKey: string;
  status: GraphQLContentStatus;
  subType?: ConfluencePageSubType | null | undefined;
  title?: string | null | undefined;
  type: string;
};
export type CreateContentMutation$data = {
  readonly createContentContextual: {
    readonly id: string | null | undefined;
    readonly links: {
      readonly context: string | null | undefined;
      readonly editui: string | null | undefined;
    } | null | undefined;
    readonly metadata: {
      readonly frontend: {
        readonly collabService: string | null | undefined;
      } | null | undefined;
    };
    readonly space: {
      readonly alias: string | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
    } | null | undefined;
    readonly subType: string | null | undefined;
  } | null | undefined;
};
export type CreateContentMutation = {
  response: CreateContentMutation$data;
  variables: CreateContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentSpecificCreateInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentSpecificCreateInput",
            "variableName": "contentSpecificCreateInput"
          },
          {
            "kind": "Variable",
            "name": "parentId",
            "variableName": "parentId"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          },
          {
            "kind": "Variable",
            "name": "subType",
            "variableName": "subType"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "createContentContextual",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          }
        ]
      },
      {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "editui"
          },
          {
            "kind": "ScalarField",
            "name": "context"
          }
        ]
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
            "kind": "LinkedField",
            "name": "frontend",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "collabService"
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "subType"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CreateContentMutation",
    "selections": (v8/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateContentMutation",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "e33ffe6be783218f5cfc2bcdf60c2bd4",
    "id": "a4d71e9d10553df176b5de5e5f79502b970da53471ef25f517d1d3342af03f24",
    "metadata": {},
    "name": "CreateContentMutation",
    "operationKind": "mutation",
    "text": "mutation CreateContentMutation($subType:ConfluencePageSubType,$spaceKey:String!,$parentId:ID,$title:String,$status:GraphQLContentStatus!,$contentSpecificCreateInput:[ContentSpecificCreateInput!],$type:String!){createContentContextual(input:{spaceKey:$spaceKey,parentId:$parentId,status:$status,type:$type,subType:$subType,title:$title,contentSpecificCreateInput:$contentSpecificCreateInput}){id,space{id,alias,key},links{editui,context},metadata{frontend{collabService}},subType}}"
  }
};
})();

(node as any).hash = "1b1fef8d6670f5c0a944347d37faef55";

export default node;
